import {asyncComponent} from 'react-async-component';
import Svgs from './svgs';

/* istanbul ignore next */
const AsyncSvgs = asyncComponent({
    name: 'AsyncSvgs',
    resolve: () => Promise.resolve(Svgs),
    serverMode: 'defer'
});

export default AsyncSvgs;


// WEBPACK FOOTER //
// ./src/universal/abacus/waterfall/async-svgs.js